import React, { useContext, useState, useEffect } from "react";
import { ProfileContext } from "../../context/ProfileContext";
import { supabase } from "../../lib/supabaseClient";
import { useTranslation } from "react-i18next";

const EditProfile = ({ showBirthYearField = true }) => {
  const { profile, updateProfile } = useContext(ProfileContext);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    last_name: "",
    first_name: "",
    company: "",
    birth_year: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (profile) {
      setFormData({
        last_name: profile.last_name || "",
        first_name: profile.first_name || "",
        company: profile.company || "",
        birth_year: profile.birth_year || "",
        password: "",
        confirmPassword: "",
      });
    }
  }, [profile]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { last_name, first_name, birth_year, password, confirmPassword } =
      formData;

    // Champs requis
    if (!last_name.trim() || !first_name.trim()) {
      alert(t("profile.edit.error.required"));
      return;
    }

    // ✅ Validation année de naissance UNIQUEMENT si le champ est affiché
    let birthYearInt = null;
    if (showBirthYearField) {
      const currentYear = new Date().getFullYear();
      birthYearInt = parseInt(birth_year, 10);
      if (
        isNaN(birthYearInt) ||
        birthYearInt < 1900 ||
        birthYearInt > currentYear
      ) {
        alert(t("profile.edit.error.birthYear", { currentYear }));
        return;
      }
    }

    // Mots de passe
    if (password && password !== confirmPassword) {
      alert(t("profile.edit.error.passwordMatch"));
      return;
    }

    try {
      // Mise à jour du mot de passe
      if (password) {
        const { error } = await supabase.auth.updateUser({ password });
        if (error) throw error;
      }

      // ✅ Préparer les données de mise à jour
      const updateData = {
        last_name: formData.last_name,
        first_name: formData.first_name,
        company: formData.company,
        updated_at: new Date().toISOString(),
      };

      // ✅ Ajouter birth_year UNIQUEMENT si le champ est affiché
      if (showBirthYearField && birthYearInt) {
        updateData.birth_year = birthYearInt;
      }

      // Mise à jour du profil
      const { error: updateError } = await supabase
        .from("profiles")
        .update(updateData)
        .eq("id", profile.id);

      if (updateError) throw updateError;

      updateProfile({
        ...formData,
        birth_year: showBirthYearField ? birthYearInt : profile.birth_year,
      });

      alert(t("profile.edit.success"));
    } catch (error) {
      console.error("Erreur :", error.message);
      alert(t("profile.edit.error.generic", { message: error.message }));
    }
  };

  return (
    <form
      className="p-6 md:p-7 bg-white rounded-2xl border border-neutral-200 shadow-sm space-y-4"
      onSubmit={handleSubmit}
    >
      <h2 className="text-xl font-semibold" style={{ fontFamily: "Georgia, serif" }}>
        {t("profile.edit.title")}
      </h2>

      <div>
        <label className="block text-sm mb-1">{t("profile.edit.lastName")}</label>
        <input
          type="text"
          className="form-control-artsy w-full"
          value={formData.last_name}
          onChange={(e) =>
            setFormData({ ...formData, last_name: e.target.value })
          }
        />
      </div>

      <div>
        <label className="block text-sm mb-1">{t("profile.edit.firstName")}</label>
        <input
          type="text"
          className="form-control-artsy w-full"
          value={formData.first_name}
          onChange={(e) =>
            setFormData({ ...formData, first_name: e.target.value })
          }
        />
      </div>

      <div>
        <label className="block text-sm mb-1">{t("profile.edit.company")}</label>
        <input
          type="text"
          className="form-control-artsy w-full"
          value={formData.company}
          onChange={(e) =>
            setFormData({ ...formData, company: e.target.value })
          }
        />
      </div>

      {/* ✅ Masquer année de naissance pour Admin/Team */}
      {showBirthYearField && (
        <div>
          <label className="block text-sm mb-1">{t("profile.edit.birthYear")}</label>
          <input
            type="text"
            className="form-control-artsy w-full"
            value={formData.birth_year}
            onChange={(e) =>
              setFormData({ ...formData, birth_year: e.target.value })
            }
          />
        </div>
      )}

      <div>
        <label className="block text-sm mb-1">{t("profile.edit.password")}</label>
        <input
          type="password"
          className="form-control-artsy w-full"
          autoComplete="new-password"
          onChange={(e) =>
            setFormData({ ...formData, password: e.target.value })
          }
        />
      </div>

      <div>
        <label className="block text-sm mb-1">
          {t("profile.edit.confirmPassword")}
        </label>
        <input
          type="password"
          className="form-control-artsy w-full"
          autoComplete="new-password"
          onChange={(e) =>
            setFormData({
              ...formData,
              confirmPassword: e.target.value,
            })
          }
        />
      </div>

      <button type="submit" className="btn-artsy btn-primary-artsy">
        {t("profile.edit.save")}
      </button>
    </form>
  );
};

export default EditProfile;